import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  //background-color: white;
  //min-height: 40px;
  height: 140px;
  border-bottom: thin solid darkgrey;

  .imgBg {
    //border-top-right-radius: 20px;
    //border-bottom-right-radius: 20px;
    width: 35%;
    height: 140px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    float: left;
    //background-Color: white;
    //margin-Top: 8px;
    margin-Bottom: 8px;
  }

  .vodBg {
    //border-top-right-radius: 20px;
    //border-bottom-right-radius: 20px;
    width: 35%;
    height: 140px;
    background-repeat: no-repeat;
    background-size: 100% 80%;
    background-position: top;
    float: left;
    //background-Color: white;
    margin-Top: 8px;
    margin-Bottom: 8px;
  }

  .baseDiv {
    //backgroundColor: white;
    //margin: 8px;

  }

  .chartNum {
    height: 140px;
    float: left;
    line-Height: 50px;
    text-Align: center;
    background-repeat:no-repeat;
    background-position:top center;
    // border-Top-Left-Radius: 20px;
    // border-Bottom-Left-Radius: 20px;
   // margin-Top: 8px;
   // margin-Bottom: 8px;
    //background-Color: white;
    width: 10%;
  }
  
  .badge{
    margin-left: 12px;
    padding: 0 3px;
    background-color: #21b68a;
    border-radius: 2px;
  }

  .creationDes {
    display: table-cell;
    vertical-Align: top;
    padding-Left: 10px;
  }

  .cDes {
    height: 140px;
    width: 50%;
    float: left;
    //background-Color: white;
    display: table;
    margin-Top: 8px;
    margin-Bottom: 8px;
  }


  .title {
    width: 90%;
    font-size: 18px;
  }

  .titleSmall {
    width: 90%;
    font-size: 12px;
  }
  .am-badge{
    display: block;
    height: 22px;
  }
  .grid-item{
    margin: 0 4px;
  }

  .textContent {
    width: 90%;
    font-size: 10px;
    margin: 1px;
    padding: 0px;
    color: #8F999F;
  }

  .textRightBottom {
    color: darkgray;
    width: 43vw;
    height: 48vw;
    display: table-cell;
    vertical-align: bottom;
    text-align: right;
  }

  .imgCenter {
    width: 43vw;
    height: 48vw;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }

  .userName {
    height: 32px;
    line-height: 16px;
    width: 100%;
    font-size: 12px;
    color: darkgray;
  }

  .divider {
    margin-top: 0;
    margin-bottom: 8px;
  }

  .grid {
    height: 40px;
  }

  .voteCount {
    height: 20px;
    line-height: 16px;
    width: 100%;
    text-align: left;
    font-size: 16px;
    color: #36BEF1;
  }

  .noDiv {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 10%;
    height: 140px;
    float: left;
    //backgroundColor:white
  }


`
